// custom utils
import {LANGUAGES} from "../../../utils/langUtils";

/** Obtained time data in UTC format from Internal system are transformed into format according to the selected LANGUAGE 
 * @param dateStr string with date and time in UTC format
 * @param language active language on the frontend side
 * @returns string containing day + month + year in standard format in the selected LANGUAGE
*/
export function parseIsoDatetime(dateStr:any, language:any) {

    if(language === LANGUAGES.Czech) {
        // year-month-day (XXXX-XX-XX)
        var date = dateStr.split("T");
        // year | month | day
        var dateSplitted = date[0].split("-");
        // corresponding words for months in given language
        let month = ["LEDNA", "ÚNORA","BŘEZNA","DUBNA","KVĚTNA","ČERVNA","ČERVENCE","SRPNA","ZÁŘÍ","ŘÍJNA","LISTOPADU", "PROSINCE"]
        // Czech date format (24. ledna 2023)
        return String((dateSplitted[2])+'. ' + (month[(parseInt(dateSplitted[1])) - 1]) + ' ' +  dateSplitted[0]);
    }
    else if (language === LANGUAGES.English) {
        // year-month-day (XXXX-XX-XX)
        var date = dateStr.split("T");
        // year | month | day
        var dateSplitted = date[0].split("-");
        // corresponding words for months in given language
        let month = ["JANUARY", "FEBRUARY","MARCH","APRIL","MAY","JUNE","JULY","AUGUST","SEPTEMBER","OCTOBER","NOVEMBER", "DECEMBER"]
        // English date format (January 24, 2023)
        return String((month[(parseInt(dateSplitted[1])) - 1]) + ' ' + (dateSplitted[2])+', ' + dateSplitted[0]);
    }
    // TODO 
    else if (language === LANGUAGES.German) {
        return "-";
    }
}